module.exports = __webpack_public_path__ + "img/Slider CierraCinta.f917133c.png";